import React from "react";

export default function Education() {
  return (
    <div className="education" id="education">
      <div className="main-text">
        <h2>My Education.</h2>
      </div>
      <div className="grid campo">
      <div className="box">
          <img src={require("../img/jkuat.png")} alt="University" />
          <h2>
            Jomo Kenyatta University of Agriculture and Technology.(2018-2019)
          </h2>
          <p>Backelors in Information Technology</p>
        </div>
        <div className="box uni2">
          <img src={require("../img/jkuat.png")} alt="University" />
          <h2>
            Jomo Kenyatta University of Agriculture and Technology.(2019-2021)
          </h2>
          <p>Diploma in Business Information Technology</p>
        </div>
        <div className="box uni2">
          <img src={require("../img/jkuat.png")} alt="University" />
          <h2>
            Jomo Kenyatta University of Agriculture and Technology.(2018-2019)
          </h2>
          <p>Certificate in Information Technology</p>
        </div>
        <div className="box uni3">
          <img src={require("../img/images.png")} alt="University" />
          <h2>
            Moringa School.(2022-2023)
          </h2>
          <p>Certificate in Software Engineering</p>
        </div>
      </div>
    </div>
  );
}
